import { lazy, Suspense, useEffect, useState } from "react";
import { AgentDeviceSetup } from "@/components/AgentDeviceSetup";
import { BootReady } from "@/components/WakeAssistant";
import { hasRequiredRoomParams } from "@/lib/room-context";

const WakeAssistant = lazy(() =>
  import("@/components/WakeAssistant").then((m) => ({
    default: m.WakeAssistant,
  })),
);

function BootFallback() {
  return (
    <div className="assistant">
      <div className="assistant__stage">
        <BootReady />
      </div>
    </div>
  );
}

export function ClientHome() {
  const [ready, setReady] = useState(false);
  const [hasParams, setHasParams] = useState(false);

  useEffect(() => {
    setHasParams(hasRequiredRoomParams());
    setReady(true);
  }, []);

  if (!ready) {
    return <BootFallback />;
  }

  // Device picker requires auth so we know the tenant before checking Concierge status.
  if (!hasParams) {
    return <AgentDeviceSetup />;
  }

  return (
    <Suspense fallback={<BootFallback />}>
      <WakeAssistant />
    </Suspense>
  );
}
